import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { UrgentAlertsListRoute } from '@/features/incidents/v2/urgent-alerts/urgent-alerts-routes'

/** Static, so it wins over `/incidents/$incidentId`. */
export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/urgent-alerts/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: UrgentAlertsListRoute,
})
